export const organImages = [
  {
    src: "/images/organs/Allergy.png",
    alt: "Allergy",
  },
  {
    src: "/images/organs/Cardiac.png",
    organ: "/",
    alt: "Cardiac",
  },
  {
    src: "/images/organs/Diabetic.png",
    alt: "Diabetic",
  },
  {
    src: "/images/organs/Fever.png",
    alt: "Fever",
  },
  {
    src: "/images/organs/Kidney.png",
    alt: "Kidney",
  },
  {
    src: "/images/organs/Liver.png",
    alt: "Liver",
  },
  {
    src: "/images/organs/Lungs.png",
    alt: "Lungs",
  },
  {
    src: "/images/organs/Pancreatic.png",
    alt: "Pancreatic",
  },
  {
    src: "/images/organs/Pregnancy.png",
    alt: "Pregnancy",
  },
  {
    src: "/images/organs/Prostate.png",
    alt: "Prostate",
  },
  {
    src: "/images/organs/Thyroid.png",
    alt: "Thyroid",
  },
];

// export const initialTests = [
//   {
//       "id": "INV100",
//       "name": "Allergen Panel-Veg + Inhalant",
//       "price": 4000,
//       "sample_type": "Pleural fluid, csf",
//       "pre_test_preparation": "No special prepration required",
//       "test_report_delivery": "Same day Report",
//       "frequency": "As prescribed by your Doctor",
//       "home_sample_collection": "Location",
//       "category": "Prostate"
//   },
//   {
//       "id": "INV101",
//       "name": "Allergen Panel-Veg + Non-Veg",
//       "price": 8000,
//       "sample_type": "10 mL Peritoneal Fluid",
//       "pre_test_preparation": "No special prepration required",
//       "test_report_delivery": "Same day Report",
//       "frequency": "As prescribed by your Doctor",
//       "home_sample_collection": "Location",
//       "category": "Thyroid"
//   },
//   {
//       "id": "INV102",
//       "name": "Allergen Panel-Veg+Non Veg.+Inhalant",
//       "price": 10000,
//       "sample_type": "Urine",
//       "pre_test_preparation": "No special prepration required",
//       "test_report_delivery": "Same day Report",
//       "frequency": "As prescribed by your Doctor",
//       "home_sample_collection": "Location",
//       "category": "Heart"
//   },
//   {
//       "id": "INV103",
//       "name": "Allergen Panel-Veg+Non Veg.+Inhalant+Drugs",
//       "price": 15000,
//       "sample_type": "Blood",
//       "pre_test_preparation": "No special prepration required",
//       "test_report_delivery": "Same day Report",
//       "frequency": "As prescribed by your Doctor",
//       "home_sample_collection": "Location",
//       "category": "Diabetes"
//   },
//   {
//       "id": "INV104",
//       "name": "Allergen Panel-Vegetarian",
//       "price": 6000,
//       "sample_type": "Pleural fluid, csf",
//       "pre_test_preparation": "No special prepration required",
//       "test_report_delivery": "Same day Report",
//       "frequency": "As prescribed by your Doctor",
//       "home_sample_collection": "Location",
//       "category": "Allergy"
//   },
//   {
//       "id": "INV105",
//       "name": "ALLERGY PANEL (FOOD AND DRUGS)",
//       "price": 12000,
//       "sample_type": "11 mL Peritoneal Fluid",
//       "pre_test_preparation": "No special prepration required",
//       "test_report_delivery": "Same day Report",
//       "frequency": "As prescribed by your Doctor",
//       "home_sample_collection": "Location",
//       "category": "Kidneys"
//   }
// ]

export const testsData = [
  {
    id: 1,
    category: "Blood",
    organ: "/images/organs/Heart.png",
    title: "HbA1c (Glycated Haemoglobin)",
    price: 2000,
    inv: "INV1663",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
  {
    id: 2,
    category: "Heart",
    organ: "/images/organs/Heart.png",
    title: "IHC ER/PR/HER2nu(BREAST PANEL)",
    price: 4000,
    inv: "INV1441",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
  {
    id: 3,
    category: "Cells",
    organ: "/images/organs/Thyroid.png",
    title: "HbA1c (Glycated Haemoglobin)",
    price: 2000,
    inv: "INV1663",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
  {
    id: 4,
    category: "Breast",
    organ: "/images/organs/Heart.png",
    title: "IHC ER/PR/HER2nu(Breast panel) + Ki-67",
    price: 5000,
    inv: "INV2408",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
  {
    id: 5,
    category: "Scan",
    organ: "/images/organs/Heart.png",
    title: "10X300 SWAB C/S",
    price: 3000,
    inv: "INV1441",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
  {
    id: 6,
    category: "lung",
    organ: "/images/organs/Heart.png",
    title: "17-Ketosteroids",
    price: 1700,
    inv: "INV3",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
  {
    id: 6,
    category: "Heart",
    organ: "/images/organs/Heart.png",
    title: "17-Ketosteroids",
    price: 1700,
    inv: "INV3",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
  {
    id: 7,
    category: "Heart",
    organ: "/images/organs/Heart.png",
    title: "17-Ketosteroids",
    price: 1700,
    inv: "INV3",
    description:
      "Excepteur sint occaecat cupidatat non proident, sunt in culpa",
  },
];

export const ytPatExpVids = [
  {
    id: 1,
    vidCode: "O5OmR3qcXVI",
  },
  {
    id: 2,
    vidCode: "hBE14y9zUKI",
  },
  {
    id: 3,
    vidCode: "NdGRpPOwPZk",
  },
  {
    id: 4,
    vidCode: "6Hk_FrWZa9E",
  },
  {
    id: 5,
    vidCode: "UaLYILf7Hs8",
  },
];

export const patientStoryData = [
  {
    id: 1,
    photo: "/images/patients/patient1.jpg",
    video: "/images/videos/pe_vid1.mp4",
    name: "Mounya Dutta",
    info: "unde Description unde omnis one",
    bg: "/images/Konnect_Patient_experience_bg1_img.jpg",
    description:
      "I've been consistently impressed with the impeccable service and accurate results provided by Konnect Diagnostic Center. Their skilled team and state-of-the-art equipment ensure a seamless experience every time. I trust them with my health without hesitation.",
  },
  {
    id: 2,
    photo: "/images/patients/patient2.jpg",
    video: "https://www.youtube.com/watch?v=ZSM3w1v-A_Y",
    name: "Arun Banurelli",
    info: "The unde Description unde omnis two ",
    bg: "/images/Konnect_Patient_experience_bg2_img.jpg",
    description:
      "Konnect Diagnostic Center has truly redefined healthcare for me. Their commitment to precision and patient care is evident in every interaction. From quick appointments to comprehensive reports, they make the diagnostic process smooth and reliable.",
  },
  {
    id: 3,
    photo: "/images/patients/patient3.jpg",
    name: "Neha",
    info: "The unde Description unde omnis three ",
    bg: "/images/Konnect_Patient_experience_bg3_img.jpg",
    description:
      "As a healthcare professional, I demand accuracy and efficiency in diagnostics. Konnect Diagnostic Center has become my go-to choice. The proficiency of their staff and the range of tests available make them an invaluable asset in ensuring my patients receive the best possible care.",
  },
  {
    id: 4,
    photo: "/images/patients/patient4.jpg",
    name: "Ashwin Nayak",
    info: "The unde Description unde omnis four ",
    bg: "/images/Konnect_Patient_experience_bg4_img.jpg",
    description:
      "I can't thank Konnect Diagnostic Center enough for their prompt and friendly service. Nervous about my tests, their compassionate staff immediately put me at ease. The results were delivered with clarity, and I am grateful for their role in keeping my health in check.",
  },
  {
    id: 5,
    photo: "/images/patients/patient5.jpg",
    name: "Hrithika singh",
    info: "The unde Description unde omnis five ",
    bg: "/images/Konnect_Patient_experience_bg5_img.jpg",
    description:
      "Konnect Diagnostic Center stands out in its commitment to quality and reliability. My family and I have been using their services for years, and they continue to impress us with their attention to detail and the personalized care they provide. Truly a center that cares.",
  },

  {
    id: 6,
    photo: "/images/patients/patient6.jpg",
    name: "Kalpana Nadumuri",
    info: "The unde Description unde omnis six ",
    bg: "/images/Konnect_Patient_experience_bg6_img.jpg",
    description:
      "Choosing Konnect Diagnostic Center was a game-changer for me. Their cutting-edge technology and skilled professionals ensure that I receive accurate results, allowing me to make informed decisions about my health. Their dedication to excellence is commendable.",
  },
];
